import TimelineItemModel from "./TimelineItemModel";

/** VIS-timeline native Group model */
export default class TimelineGroupModel {
	constructor(data?: any) {
		if (data) {

			this.id = data.id ?? 0;
			this.name = data.name ?? '';
			this.head = data.head ?? false;
			this.virtualOrder = data.virtualOrder ?? false;

			if (data.subGroups?.length) {
				this.subGroups = data.subGroups.map((_: any) => new TimelineGroupModel(_));
			}

			if (data.slots?.length) {
				this.slots = data.slots.map((_: any) => new TimelineItemModel(_));
			}

			if (data.props) {
				this.props = data.props;
			}
		}
	}

	id: string | number = 0;
	name = '';
	head = false;
	subGroups: Array<TimelineGroupModel> | null = null;
	slots: Array<TimelineItemModel> | null = null;
	props: any = null;
	virtualOrder = false;
}
